"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SolarPanelFoundry = void 0;
var CardName_1 = require("../../CardName");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var Resources_1 = require("../../Resources");
var CardRenderer_1 = require("../render/CardRenderer");
var Card_1 = require("../Card");
var SolarPanelFoundry = (function (_super) {
    __extends(SolarPanelFoundry, _super);
    function SolarPanelFoundry() {
        return _super.call(this, {
            name: CardName_1.CardName.SOLAR_PANEL_FOUNDRY,
            cardType: CardType_1.CardType.ACTIVE,
            tags: [Tags_1.Tags.ENERGY, Tags_1.Tags.MOON, Tags_1.Tags.BUILDING],
            cost: 11,
            metadata: {
                cardNumber: 'M89',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.action('Spend 2 Steel to increase your Energy Production 1 step.', function (eb) { return eb.startAction.steel(2).arrow().production(function (pb) { return pb.energy(1); }); });
                }),
            },
        }) || this;
    }
    ;
    SolarPanelFoundry.prototype.play = function () {
        return undefined;
    };
    SolarPanelFoundry.prototype.canAct = function (player) {
        return player.steel >= 2;
    };
    SolarPanelFoundry.prototype.action = function (player) {
        player.deductResource(Resources_1.Resources.STEEL, 2);
        player.addProduction(Resources_1.Resources.ENERGY, 1);
        return undefined;
    };
    return SolarPanelFoundry;
}(Card_1.Card));
exports.SolarPanelFoundry = SolarPanelFoundry;
//# sourceMappingURL=SolarPanelFoundry.js.map